module.exports = __webpack_public_path__ + "img/denglu-top.3feef650.png";